import { ConfigData } from "@configs/config-data.type";

export const sacylPXCfg: ConfigData = {
	apiUrl: 'https://api-core-resi.px.sacyl.es',
	title: 'Core',
	logos: {
		login: 'assets/images/logos/sacyl/logo-text-white-v2.png',
		menu: 'assets/images/logos/sacyl/logo-text-white.png',
	},
};
